import { forwardRef, useImperativeHandle } from "react";
import { Form } from "react-bootstrap";

function Barcode(props, ref) {

    useImperativeHandle(ref, () => ({
        getName: getName,
        getType: getType,
        getTitle: getTitle,
        hasSettings: hasSettings,
        getSettings: getSettings,
        getDefaultOptions: () => ({ action: 'skip' })
    }));

    const getName = () => {
        return 'Баркод';
    }

    const getType = () => {
        return 'barcode';
    }

    const getTitle = () => {
        return null;
    }

    const hasSettings = () => true;

    const getSettings = ({ state, setConfig }) => {
        return (
            <div>
                <label>
                    Действия при несъществуващ артикул:
                </label>
                <div>
                    <Form.Check
                        id={'cb-skip'}
                        type="radio"
                        label="Прескочи реда"
                        checked={state.options?.action === 'skip'}
                        onChange={e => setConfig('action', 'skip')}
                    />
                    <Form.Check
                        id={'cb-abort'}
                        type="radio"
                        label="Прекрати импорта"
                        checked={state.options?.action === 'abort'}
                        onChange={e => setConfig('action', 'abort')}
                    />
                </div>
            </div>
        )

    }

    return getName();
}

export default forwardRef(Barcode)